module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_intro",
    attrs: {
      "epub:type": "introduction"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("INTRODUCTION")])]), _c('h1', {
    staticClass: "pre_stit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_vm._v("What Is a Minority?")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("What does it mean to be a minority? It may not be what you think or have heard.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("After all, you could be fluent in Chinese language and customs, and yet not understand how Asian Americans feel like they can never truly be accepted in society. You could be the only white person in a group of a hundred people of color, and still be a “majority.” You might debate for hours about immigration policy, and miss why historical events make the issue so loaded for Latinos.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("That’s because the minority experience isn’t primarily about head knowledge—but about emotional realities of "), _c('i', [_vm._v("pain")]), _vm._v(".")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The minority experience isn’t about sheer numbers or demographic percentages—but about who holds "), _c('i', [_vm._v("power")]), _vm._v(".")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The minority experience isn’t just about current events and politics—but even more about how these things are impacted by "), _c('i', [_vm._v("the past")]), _vm._v(".")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("Throughout my research on race and diversity, and my decades of work in crosscultural leadership development, I’ve found that these three categories define so much that is distinctive about what it means to be a minority.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Pain, power, and the past are three filters through which we can view anything related to race. When we’re trying to understand what it means to be African American, do we seek to hear their emotional realities of pain? When we’re seeking to diversify our organization, are we treating everyone as if they are on “equal ground,” or are we understanding that some are naturally disadvantaged because of sociological disparities of power? When we talk with a coworker about a race-related topic in the news (e.g., the Dakota Access Pipeline"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-006",
      "id": "ap_ntf-006-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v("), are we asking about how the past events of history might impact the discussion? If we apply these three filters, we will be well on our way to truly understanding the minority experience.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I have structured this book in two parts. Part one is called “Understanding the Minority Experience,” and "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap1#chap-001"
    }
  }, [_vm._v("chapters one")]), _vm._v(", three, and four each describe a particular aspect of pain, power, and the past in depth. "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap2#chap-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter two")]), _vm._v(" provides a high-level view of these three categories and defines some terms related to race. Part two is called “Redeeming the Minority Experience.” "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap1#chap-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter five")]), _vm._v(" outlines some specific applications and principles for organizations as they seek to take the next step in diversifying. "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap2#chap-006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapters six")]), _vm._v(", "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap3#chap-007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("seven")]), _vm._v(", and "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p2chap4#chap-008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("eight")]), _vm._v(" provide some guidance for how minorities can use pain, power, and the past to build compassion, advocacy, and wisdom, respectively.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("Throughout this book, I will define race-related terms and language as necessary, but I’d like to start with a few foundational definitions here. I’ve learned the importance of words, because they carry connotations of pain for some or have been used as weapons of power by others. Many words have significance from the past, and language and meaning are continually evolving.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("First, there is a critical difference between the terms "), _c('i', [_vm._v("ethnicity")]), _vm._v(" and "), _c('i', [_vm._v("race")]), _vm._v(". Confusing the two terms can be unhelpful. "), _c('i', [_vm._v("Ethnicity")]), _vm._v(" refers to the various ancestral attributes that distinguish a people group, including appearance, language, customs, religious practices, and so on. For instance, Irish and Italian Americans are ethnic groups.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Race")]), _vm._v(", on the other hand, is a category with a history and purpose of social power. According to most scholars, race was defined as a way to unify various European ethnic groups into one—“white”—in order to establish control over those from other ethnic groups (e.g., blacks). Dr. Beverly Daniel Tatum, one of the foremost experts on racial identity, writes that “the original creation of racial categories was in the service of oppression.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-007",
      "id": "ap_ntf-007-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" This explains how Irish and Italian Americans used to be treated by other settlers as inferior, but at a certain point came to be seen and accepted as simply “white.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-008",
      "id": "ap_ntf-008-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" In "), _c('i', [_vm._v("The Very Good Gospel")]), _vm._v(", activist Lisa Sharon Harper cites the example of Takao Ozawa, a Japanese man who argued before the Supreme Court in 1922 that Japanese people were white. Ozawa had been restricted from clear societal benefits that came with "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("naturalization, so he sought to fit into a racial category that had nothing to do with his skin color or ethnic background!"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-009",
      "id": "ap_ntf-009-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This is such a critical distinction, because merely discussing a person’s Russian or German ethnicity does not tend to lead into conversations about the shared power from which those ethnic groups have benefited by nature of being “white.” That is one reason why I use the term “white” or majority culture—as a reminder of the pain, power, and past history associated with those words.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For people of color, I will use the terms that I hear most commonly used, or that people within those communities call themselves—Latino (though some use Hispanic American), Native American or Native peoples, Asian American (some differentiate between Asian Pacific Islanders and Asian Pacific Americans), South Asians, and so on. Some people of African descent prefer to use “African American,” while others prefer “Black” as more inclusive of Afro-Caribbeans living in the United States. Since the sources I quote use the terms fairly interchangeably, I will do the same. When I refer to the United States I try to use “United States” instead of “America,” as I recognize that many other countries are part of America (North, Central, and South). However, occasionally I use “American” to avoid literary awkwardness, or “America” for symbolic and metaphorical purposes.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("From working in ethnic leadership development, I have learned that one size does not fit all; even within a minority group there are important differences. Latinos from Mexico face different realities than those from South American countries "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("such as Peru or Argentina. Among Asian Americans, a fourth-generation Japanese American in California lives a very different life than a Hmong refugee family in Wisconsin."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-010",
      "id": "ap_ntf-010-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Some discrepancies are clear as day to me—for instance, I have lived a life of far greater privilege than many poor ethnic minorities. I can never understand the suffering Native Americans, Latinos, and African Americans have endured.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("While we cannot oversimplify the experiences of minorities, that doesn’t mean there aren’t bonds that tie us together."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-011",
      "id": "ap_ntf-011-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" I do want to acknowledge that many of the experiences and influences described in this book are from the Asian American community, as that is who I am."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-012",
      "id": "ap_ntf-012-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" However, I have sought to give examples and stories from other minority communities as well. While it is not possible to represent every minority group and subgroup, my goal is to provide examples that can apply to other contexts. My hope is that reading these stories will also catalyze other minorities to keep writing and sharing the perspectives that we need so badly to hear.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Second, let’s define what we mean when we use the word "), _c('i', [_vm._v("culture")]), _vm._v(". I like what professor Soong-Chan Rah writes: “Culture is a human attempt to understand the world around us. It is the programming that shapes who we are and who we are becoming. It is a social system that is shaped by the individual and that also has the capacity to shape the individual. But it is also the presence of God, the image of God, the mission of God found in the human spirit, soul, and social system.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-013",
      "id": "ap_ntf-013-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" In this book, I use "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("“culture” in this broad sociological and theological sense, as in “majority culture” or “organizational culture.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-014",
      "id": "ap_ntf-014-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I’ve mentioned that this book is written from a perspective of faith, and some of the scholars and authors I cite are of the Christian persuasion. That isn’t to say that Christians or churches have all the answers to the issue of race and diversity. In fact, many of us have been some of the worst offenders in escalating debates and taking sides along political lines. Not only that, but Christians have been complicit in some of the greatest racial abuses throughout history, including slavery."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-015",
      "id": "ap_ntf-015-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" As a Christian, that is part of my history, and I write as someone grieved by these corruptions and departures from what faith should be.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("At the same time, I have met many Christians who advocate for justice and minority issues, and many of the authors I cite have given their work and lives for these causes. They live out what I consider “the kingdom of God”—a vision of reality that Jesus taught, where the weak and poor are uplifted, and justice and peace are pursued with courage and sacrifice (Matthew 5:1-12). In this kingdom, people love with patience and are slow to anger (1 Corinthians 13:4-8). They are not quick to judge or hurl accusations as we are used to seeing in discussions about race. As a Christian, I believe that relying on our own willpower gets us stuck in destructive cycles of debate. If we truly submit to God, there’s a way to break out of these cycles. This book is written with that hope and perspective."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-016",
      "id": "ap_ntf-016-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Third, you’ll notice that I intentionally use the term "), _c('i', [_vm._v("minority.")]), _vm._v(" Many scholars in racial studies also use the term comfortably, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("while a few choose not to because of the reality that people of color will soon outnumber white populations in the United States. (Both CNN and the"), _c('i', [_vm._v(" New York Times")]), _vm._v(" report that within a generation, ethnic minorities will make up more than 50 percent of the overall population in the United States."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-017",
      "id": "ap_ntf-017-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(")")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I choose to use the term "), _c('i', [_vm._v("minority")]), _vm._v(" and reframe it, not in terms of demographic numbers but in terms of who holds societal power."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-018",
      "id": "ap_ntf-018-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Dr. Martin Luther King Jr. once said that “equality is not only a matter of mathematics and geometry, but it’s a matter of psychology. . . . It is possible to have a quantitative equality and qualitative inequality.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-019",
      "id": "ap_ntf-019-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" This means that many minorities are not born with the same advantages as white people, even in something as simple as expecting other people around the world to speak English rather than having to learn local dialects. This has nothing to do with numbers—consider how many people live in India and China, yet neither Hindi nor Chinese are “default” worldwide languages. Very few people I know would posit that this kind of white status and privilege will suddenly disappear during the year that ethnic minorities hit 51 percent of the United States population. Furthermore, the math just wouldn’t add up. Five percent of Asian Americans together with 15 percent of Latinos does not make either group feel like 20 percent. The sum of all ethnic minorities (even above 50 percent) does not translate into one unified, dominant force.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Finally, for some people, the words "), _c('i', [_vm._v("emotions")]), _vm._v(" and "), _c('i', [_vm._v("emotional")]), _vm._v(" can have connotations that aren’t positive—such as lacking stability, composure, or resilience. When I use these words, I mean the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("deeper forces that drive human beings, such as needs, desires, and fears. I believe that while many of us like to think we are mostly rational beings, emotions drive the vast majority of our decisions and actions. So that is why I choose to focus on uncovering some of the deepest emotional realities for minorities in the chapters that follow.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As you read, pay attention to what kinds of emotions and reactions are brought to the surface. Which stories make you sad or stir up your sense of injustice? Which experiences remind you of your own childhood or past? What questions do you have, and what do you still want to learn more about? I’ve included some reflection and discussion questions at the end of the book, so that you can have a conversation with a friend, coworker, or small group as you read.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("There’s so much to learn—and every lesson reminds me that we all can make a difference in the ongoing conversation about race, power, and diversity. There may be no better time for this discussion, as racial tension and violence persists in the news and crosscultural conversations appear as polarizing as ever. We all have a story to share, and we all have an important role to play in this conversation.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 69
// module chunks = 0